import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import { initSentry } from './config/sentry'
import { dropLegacyApiCaches } from './api/offlineCache'
import App from './App.tsx'

initSentry()
dropLegacyApiCaches()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
